import { Outlet } from "react-router-dom";
import LandingPageHeader from "./LandingPageHeader";
import { ChatIcon } from "../../../shared/cockpit/components/icons/Icon";
import "./LandingPageLayout.scss";

export default function LandingPageLayout() {
  return (
    <div className="landing-page-layout">
      <LandingPageHeader />
      <main className="landing-page-layout__content">
        <Outlet />
      </main>
      <button className="chat-button" aria-label="Chat">
        <ChatIcon className="chat-button__icon" />
      </button>
    </div>
  );
}
